import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
} from "./schema.orderLocationDescription.1";
import { IExtraData } from "./schema.orderLocationDescription.types";
import { getInitialValues } from "./schema.orderLocationDescription.utils";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);
  return [
    {
      schema: getSchema1(initialValues, extraData),
      uiSchema: uiSchema1(extraData),
    },
  ];
};
